export const SLOT_NAME_APPEND = 'append'
export const SLOT_NAME_BOTTOM_ROW = 'bottom-row'
export const SLOT_NAME_BUTTON_CONTENT = 'button-content'
export const SLOT_NAME_CUSTOM_FOOT = 'custom-foot'
export const SLOT_NAME_DEFAULT = 'default'
export const SLOT_NAME_DESCRIPTION = 'description'
export const SLOT_NAME_EMPTY = 'empty'
export const SLOT_NAME_EMPTYFILTERED = 'emptyfiltered'
export const SLOT_NAME_FIRST = 'first'
export const SLOT_NAME_HEADER = 'header'
export const SLOT_NAME_INVALID_FEEDBACK = 'invalid-feedback'
export const SLOT_NAME_LABEL = 'label'
export const SLOT_NAME_MODAL_BACKDROP = 'modal-backdrop'
export const SLOT_NAME_MODAL_CANCEL = 'modal-cancel'
export const SLOT_NAME_MODAL_FOOTER = 'modal-footer'
export const SLOT_NAME_MODAL_HEADER = 'modal-header'
export const SLOT_NAME_MODAL_HEADER_CLOSE = 'modal-header-close'
export const SLOT_NAME_MODAL_OK = 'modal-ok'
export const SLOT_NAME_MODAL_TITLE = 'modal-title'
export const SLOT_NAME_PREPEND = 'prepend'
export const SLOT_NAME_ROW_DETAILS = 'row-details'
export const SLOT_NAME_TABLE_BUSY = 'table-busy'
export const SLOT_NAME_TABLE_CAPTION = 'table-caption'
export const SLOT_NAME_TABLE_COLGROUP = 'table-colgroup'
export const SLOT_NAME_TABS_END = 'tabs-end'
export const SLOT_NAME_TABS_START = 'tabs-start'
export const SLOT_NAME_TOOLBAR_END = 'toolbar-end'
export const SLOT_NAME_TOOLBAR_START = 'toolbar-start'
export const SLOT_NAME_TEXT = 'text'
export const SLOT_NAME_THEAD_TOP = 'thead-top'
export const SLOT_NAME_TITLE = 'title'
export const SLOT_NAME_TOAST_TITLE = 'toast-title'
export const SLOT_NAME_TOP_ROW = 'top-row'
export const SLOT_NAME_VALID_FEEDBACK = 'valid-feedback'
